import UserRoleEnum from '../../../../constants/UserRoleEnum';

const hasRole = (user, role) => Array.isArray(user && user.roles) && user.roles.includes(role);

export const isOwnDisplay = (display, user) => {
  if (!display || !user) return false;
  const company = display.company || {};

  const displayCompanyId = display.company_id || company.id;
  const isOwnCompany =
    displayCompanyId != null &&
    user.company_id != null &&
    Number(displayCompanyId) === Number(user.company_id);

  const displayHoldingId = display.holding_id || company.holding_id;
  const isOwnHolding =
    hasRole(user, 'holding-member') &&
    !!user.holding &&
    displayHoldingId != null &&
    user.holding.id === displayHoldingId;

  return isOwnCompany || isOwnHolding;
};

export const getRulesEditableContents = ({ customContents, cart, user, programmatic }) => {
  if (!Array.isArray(customContents)) return [];
  if (programmatic === 'programmatic') return customContents;
  if (hasRole(user, UserRoleEnum.superAdmin)) return customContents;
  if (!user || !user.company || user.company.type !== 'media') return [];

  const displays = Array.isArray(cart) ? cart : [];
  const ownDisplayIds = new Set(
    displays.filter(display => isOwnDisplay(display, user)).map(display => display.id)
  );
  return customContents.filter(content => ownDisplayIds.has(content.displayId));
};
